import { render, staticRenderFns } from "./pay-dialog.vue?vue&type=template&id=65b52760&scoped=true"
import script from "./pay-dialog.vue?vue&type=script&lang=js"
export * from "./pay-dialog.vue?vue&type=script&lang=js"
import style0 from "./pay-dialog.vue?vue&type=style&index=0&id=65b52760&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b52760",
  null
  
)

export default component.exports